import { API_BASE_URL } from "src/config/apiBase";
import { decryptToken } from "../Components/utils/getToken";

export async function acknowledgeCrmReminder(leadId) {
  if (!leadId) return false;
  const token = decryptToken("accessToken") || "";
  if (!token) return false;

  try {
    const res = await fetch(`${API_BASE_URL}/leads/reminder-ack/${leadId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return res.ok;
  } catch {
    return false;
  }
}

export async function snoozeCrmReminder(leadId, minutes = 60) {
  if (!leadId) return null;
  const token = decryptToken("accessToken") || "";
  if (!token) return null;

  try {
    const res = await fetch(`${API_BASE_URL}/leads/reminder-snooze/${leadId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ minutes }),
    });
    if (!res.ok) return null;
    return res.json();
  } catch {
    return null;
  }
}
